/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_PermissionsInputs */

const en_admin_nav_permissions = /** @type {(inputs: Admin_Nav_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

const zh_admin_nav_permissions = /** @type {(inputs: Admin_Nav_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限`)
};

/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Admin_Nav_PermissionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_permissions = /** @type {((inputs?: Admin_Nav_PermissionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_PermissionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_permissions(inputs)
	return zh_admin_nav_permissions(inputs)
});
export { admin_nav_permissions as "admin.nav.permissions" }